var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative slider-container" }, [
    _c("div", { ref: "controls", staticClass: "controls top-[44px]" }, [
      _c(
        "div",
        {
          staticClass:
            "bg-yellow text-black w-[30px] lg:h-[61px] h-[30px] lg:w-[61px] flex items-center justify-center control left-[30px] lg:left-[0px]"
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.svg("arrow-left", "h-[20px] stroke-black"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "bg-yellow text-black w-[30px] lg:h-[61px] h-[30px] lg:w-[61px] flex items-center justify-center control right-[30px] lg:right-[0px]"
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.svg("arrow-right", "h-[20px] stroke-black"))
            }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "slider", staticClass: "slider flex" },
      _vm._l(_vm.steps, function(step, index) {
        return _c("div", { key: step.id, staticClass: "pt-[88px] h-full" }, [
          _c(
            "div",
            {
              staticClass:
                "bg-white text-black p-32 pt-[84px] relative h-[323px]"
            },
            [
              _c("img", {
                staticClass:
                  "lazyload absolute left-[16px] top-[-88px] h-[132px]",
                attrs: { "data-src": step.image.url, alt: step.image.alt }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "flex flex-wrap gap-8 mb-24" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "bg-blue text-black px-[6px] py-[4px] uppercase font-extraBold text-16"
                  },
                  [_vm._v("Stap" + _vm._s(index + 1))]
                ),
                _vm._v(" "),
                step.is_first_class
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "bg-white text-black px-[6px] py-[4px] uppercase font-extraBold text-16"
                      },
                      [_vm._v("first class")]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "v-clamp",
                {
                  staticClass: "text-32 text-black font-extraBold mb-16",
                  attrs: { autoresize: "", "max-lines": 2, tag: "h4" }
                },
                [_vm._v(_vm._s(step.title))]
              ),
              _vm._v(" "),
              _c(
                "v-clamp",
                {
                  staticClass: "text-20 text-black",
                  attrs: { autoresize: "", "max-lines": 2, tag: "p" }
                },
                [_vm._v(_vm._s(step.content))]
              )
            ],
            1
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }